/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetSCCorrespondenceByInvInqID = require('../services/GetSCCorrespondenceByInvInqId');

var SecCorrespondenceView = require('../../common/views/SecCorrespondenceView');

module.exports = {
  channel: 'sc',

  event: 'build:inv-inq-correspondence-grid-view',

  builder: function(invInqId) {
    return new PlaceholderView({
      viewPromise: buildInvInqCorrespondenceView(invInqId)
    });
  }
};

function buildInvInqCorrespondenceView(invInqId) {
  var deferred = $.Deferred();

  GetSCCorrespondenceByInvInqID(invInqId)
    .done(function(correspondences) {
      deferred.resolve(
        new SecCorrespondenceView({
          mode: 'inv-inq',
          model: new Backbone.Model({
            invInqId: invInqId,
            correspondences: correspondences
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
